import { render } from "./ConsultantView.vue?vue&type=template&id=1891a873&ts=true"
import script from "./ConsultantView.vue?vue&type=script&lang=ts"
export * from "./ConsultantView.vue?vue&type=script&lang=ts"

import "./ConsultantView.vue?vue&type=style&index=0&id=1891a873&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__